import React, {useEffect, useState} from "react";
import {BrowserRouter} from "react-router-dom";
import {StyledEngineProvider, ThemeProvider,} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MomentUtils from "@date-io/moment";
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {TouchBackend} from 'react-dnd-touch-backend';
import LoginApp from "./loginApp";
import {isDesktop} from "react-device-detect";
import {themeObjectDark, themeObjectLight} from "../app/themes";
import ErrorBoundary from '../controls/errorBoundary';
import SystemSnackbarProvider from '../components/snackbar/systemSnackbarProvider';

function LoginMain() {
    let themeObject = themeObjectDark;

    const [theme, setTheme] = useState(themeObject);
    window._theme = theme;

    window._getTheme = () => {
        const themeName = window.localStorage.getItem('fortrus_agyle_theme');
        return themeName ? themeName : 'light';
    };
    window._getThemeObject = (themeName) => {
        return themeName === 'dark' ? themeObjectDark : themeObjectLight;
    };
    window._switchTheme = () => {
        const newTheme = window._getTheme() === 'dark' ? 'light' : 'dark';
        window.localStorage.setItem('fortrus_agyle_theme', newTheme);
        setTheme(window._getThemeObject(newTheme));
    };
    window._setTheme = (themeName) => {
        window.localStorage.setItem('fortrus_agyle_theme', themeName);
        setTheme(window._getThemeObject(themeName));
    };

    // let backend = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0) ? TouchBackend : HTML5Backend;
    let backend = isDesktop ? HTML5Backend : TouchBackend;

    // if ((new URL(document.location)).searchParams.get("touch") === "false") {
    //     backend = HTML5Backend;
    // }

    useEffect(() => {
        setTheme(window._getThemeObject(window._getTheme()));
    }, []);

    return (
        <React.StrictMode>
            {/*<Provider store={store}>*/}
            <DndProvider backend={backend}>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <CssBaseline/>
                        <BrowserRouter>
                            <LocalizationProvider dateAdapter={MomentUtils}>
                                <SystemSnackbarProvider>
                                    <ErrorBoundary>
                                        <LoginApp/>
                                    </ErrorBoundary>
                                </SystemSnackbarProvider>
                            </LocalizationProvider>
                        </BrowserRouter>
                    </ThemeProvider>
                </StyledEngineProvider>
            </DndProvider>
            {/*</Provider>*/}
        </React.StrictMode>
    );
}

export default LoginMain;
